import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './theme.css';

// Global error reporting
window.addEventListener('error', (e) => {
  const token = localStorage.getItem('novax:token') || '';
  fetch('/api/client-error', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ message: e.message, stack: e.error?.stack, filename: e.filename, lineno: e.lineno, colno: e.colno }),
  }).catch(() => {});
});
window.addEventListener('unhandledrejection', (e) => {
  const token = localStorage.getItem('novax:token') || '';
  fetch('/api/client-error', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ message: String(e.reason), stack: e.reason?.stack, source: 'unhandledrejection' }),
  }).catch(() => {});
});

// Restore message font size preference
const savedFontSize = localStorage.getItem('novax:msgFontSize');
if (savedFontSize) document.documentElement.style.setProperty('--msg-font-size', savedFontSize);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
